<glxy-badge [color]="colour">{{ state }}</glxy-badge>
